import { render } from "./CrInfo.vue?vue&type=template&id=020563ae&scoped=true"
import script from "./CrInfo.vue?vue&type=script&lang=js"
export * from "./CrInfo.vue?vue&type=script&lang=js"

import "./CrInfo.vue?vue&type=style&index=0&id=020563ae&scoped=true&lang=scss"

import exportComponent from "/home/forge/pga-beta.devserver6.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-020563ae"]])

export default __exports__